import { render, staticRenderFns } from "./BaseInfoItem.vue?vue&type=template&id=68f4c172&scoped=true&"
import script from "./BaseInfoItem.vue?vue&type=script&lang=ts&"
export * from "./BaseInfoItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInfoItem.vue?vue&type=style&index=0&id=68f4c172&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4c172",
  null
  
)

export default component.exports